/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, MouseEvent, useState } from 'react';
import { TableCell, TableRow } from '../ui/table';
import { Badge } from '../ui/badge';
import { Calendar } from 'lucide-react';
import { Button } from '../ui/button';
import useInviteClient from '@/hooks/useInviteClient';
import { toast } from 'sonner';
import UpdateClientModal from './UpdateClientModal';
import UserReportsModal from '../UserReports';

interface Props {
  row: any;
  columns: string[];
}

const renderCellValue = (value: any, column: string) => {
  if (column === 'inviteSent' || column === 'registeredAt') {
    if (!value) {
      return (
        <span className="text-muted-foreground italic">
          {column === 'inviteSent' ? 'Not sent' : 'Not created'}
        </span>
      );
    }
    return (
      <Badge variant="secondary" className="gap-1">
        <Calendar className="h-3 w-3" />
        {new Date(value).toLocaleDateString()}
      </Badge>
    );
  }

  if (value === null || value === undefined || value === '') {
    return <span className="text-muted-foreground">—</span>;
  }

  return String(value);
};

const ClientTableRow: FC<Props> = ({ row, columns }) => {
  const { mutate: inviteClient, isPending } = useInviteClient();

  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showReportsModal, setShowReportsModal] = useState(false);

  const handleInviteUser = (e: MouseEvent<HTMLButtonElement>, user: any) => {
    e.stopPropagation();

    inviteClient(
      {
        clientFirstName: user.firstName,
        clientLastName: user.lastName,
        emailAddress: user.emailAddress,
        clientId: user._id,
      },
      {
        onSuccess: () => {
          toast.success('Invite email sent!');
        },
      },
    );
  };

  return (
    <>
      <TableRow
        className="hover:bg-muted/30 cursor-pointer transition-colors"
        onClick={() => setShowUpdateModal(true)}
      >
        <>
          {columns.map((column) => (
            <TableCell key={column} className="py-3">
              {renderCellValue(row[column], column)}
            </TableCell>
          ))}
          <TableCell className="py-3">
            {!row?.registeredAt ? (
              <Button
                onClick={(e) => handleInviteUser(e, row)}
                disabled={isPending}
                className="py-1 h-fit"
              >
                Invite User
              </Button>
            ) : (
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  setShowReportsModal(true);
                }}
                disabled={isPending}
                className="py-1 h-fit"
                variant="outline"
              >
                View Reports
              </Button>
            )}
          </TableCell>
        </>
      </TableRow>
      <UpdateClientModal
        client={row}
        columns={columns}
        isOpen={showUpdateModal}
        setIsOpen={setShowUpdateModal}
      />
      <UserReportsModal
        isOpen={showReportsModal}
        setIsOpen={setShowReportsModal}
        client={row}
      />
    </>
  );
};

export default ClientTableRow;
